import Vue from 'vue';
import VueI18n from 'vue-i18n'
import App from './../apps/Header.vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/nb-NO';
import VueCookies from 'vue-cookies';
import VueMoment from 'vue-moment';

const eventsHub = new Vue()



Vue.config.productionTip = false;
Vue.use(ElementUI, {locale});
Vue.use(VueI18n)
Vue.use(VueCookies);
Vue.use(VueMoment);

export default {

    init(messages, lang) {
        const i18n = new VueI18n({
            locale: lang, // set locale
            messages, // set locale messages
        });

        new Vue({
            i18n,
            render: h => h(App)
        }).$mount('#header')
    }

}



